import { ExtractErrorMessageFnPayload } from './use-writeback-error.type';

export function extractErrorMessage({
  errorString = '',
  defaultErrorMessage,
  separator,
}: ExtractErrorMessageFnPayload): string {
  const indexOfSeparator = errorString.indexOf(separator);
  if (indexOfSeparator !== -1) {
    return `${defaultErrorMessage} - ${errorString.substring(0, indexOfSeparator)}`;
  }
  return defaultErrorMessage;
}
